import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CommingSoonThankModal from "./component";
import { reloadCarList, resetCarList } from "../car-listing/actions";

const mapStateToProps = ({
    cities: { selectedCity: { code: selectedCityCode, name: selectedCityName } = {} }
}) => ({
    selectedCityCode,
    selectedCityName
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    reloadCarListConnect: reloadCarList,
    resetCarListConnect: resetCarList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommingSoonThankModal);
